export const ONBOARDING_FORECAST_TOUR = 'onboarding-forecast-tour';
export const ONBOARDING_FORECAST_TOUR_WITHOUT_AI = 'onboarding-forecast-tour-without-ai';
export const EXISTING_USER_FMO_TOUR = 'existing-user-fmo-tour';
export const ONBOARDING_FORECAST_REP_TABLE = 'onboarding-rep-table';
export const ONBOARDING_FORECAST_CATEGORY_TAB = 'onboarding-forecast-category-tab';
export const ONBOARDING_ANALYZE_TAB = 'onboarding-analyze-tab';
export const ONBOARDING_FORECAST_SUBMISSION = 'onboarding-forecast-submission';

// FMO Tour Steps
export const FMO_TOUR_DROPDOWN_STEP = 'fmo-tour-dropdown-step';
export const FMO_TOUR_CREATE_FORECAST_STEP = 'fmo-tour-create-forecast-step';

// Onboarding V2
export const ONBOARDING_V2_TOUR = 'onboarding-v2-tour';
export const ONBOARDING_V2_TOUR_WITHOUT_ANALYZE = 'onboarding-v2-tour-without-analyze';